import * as e from "react";
import { forwardRef as r } from "react";
const c = r(function(t, l) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      fill: "none",
      ref: l,
      viewBox: "0 0 21 18",
      xmlns: "http://www.w3.org/2000/svg",
      ...t
    },
    /* @__PURE__ */ e.createElement("g", null, /* @__PURE__ */ e.createElement("path", { d: "M17.8686 18H0L3.13142 0H21L17.8686 18Z", fill: "#00FFB7" }), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M12.5892 2.8623L11.1979 7.42279L15.3762 9.17577L8.41091 15.1377L10.0695 10.5864L5.6239 8.82883L12.5892 2.8623Z",
        fill: "#000"
      }
    )),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", null, /* @__PURE__ */ e.createElement("rect", { fill: "#fff", height: 18, width: 21 })))
  );
});
export {
  c as PriceBoost
};
